<template>
  <v-card
    class="empty-state text-center"
    :class="cardClasses"
    :style="cardStyle"
    outlined
  >
    <div
      class="empty-state__content"
      :class="contentClasses"
      :style="contentStyle"
    >
      <div class="empty-state__icon">
        <component
          :is="icon"
          :size="iconSize"
          :color="iconColor"
        />
      </div>
      <span
        class="empty-state__title"
        :style="iconStyle"
      >
        {{ displayTitle }}
      </span>
      <span
        v-if="subtitle"
        class="empty-state__subtitle"
        :style="iconStyle"
      >
        {{ subtitle }}
      </span>
      <Button
        v-if="showButton"
        variant="primary"
        class="mt-4"
        :data-test="dataTestButton"
        @click="callbackButton"
      >
        {{ nameOfButton }}
      </Button>
    </div>
  </v-card>
</template>

<script>
// Components
import { PhCurrencyCircleDollar } from 'phosphor-vue';
import Button from '@/components/comum/Button.vue';

export default {
  name: 'EmptyState',
  components: {
    PhCurrencyCircleDollar,
    Button
  },
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: ''
    },
    nameOfButton: {
      type: String,
      default: ''
    },
    callbackButton: {
      type: Function,
      default: null
    },
    minHeight: {
      type: String,
      default: '200px'
    },
    icon: {
      type: [String, Object, Function],
      default: 'PhCurrencyCircleDollar'
    },
    iconSize: {
      type: Number,
      default: 48
    },
    grayBackground: {
      type: Boolean,
      default: false
    },
    dataTestButton: {
      type: String,
      default: ''
    }
  },
  computed: {
    displayTitle() {
      return this.title || this.$t('common.empty.title');
    },
    showButton() {
      return !!(this.nameOfButton && this.callbackButton);
    },
    iconColor() {
      return this.$vuetify.theme.currentTheme.table?.emptyState || '#757575';
    },
    iconStyle() {
      return { color: this.iconColor };
    },
    grayBgColor() {
      const isDark = this.$vuetify?.theme?.dark;

      return isDark ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.02)';
    },
    cardClasses() {
      return this.grayBackground ? 'empty-state--gray-bg' : 'card-cambio';
    },
    contentClasses() {
      return this.grayBackground ? 'empty-state__content--gray' : '';
    },
    cardStyle() {
      return this.grayBackground ? { backgroundColor: this.grayBgColor } : {};
    },
    contentStyle() {
      const base = { minHeight: this.minHeight };

      if (this.grayBackground) base.backgroundColor = this.grayBgColor;

      return base;
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-state__content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 32px 24px;
}

.empty-state__icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-state__title {
  display: block;
  font-size: 1.15rem;
  font-weight: 500;
  padding: 16px 0 8px;
}

.empty-state__subtitle {
  display: block;
  font-size: 0.95rem;
  text-align: center;
  opacity: 0.9;
}
</style>

<style lang="scss">
/* Mesmo cinza do fundo do nome do beneficiário (BankAccountCard/InternationalBankAccountCard __body) */
.v-card.empty-state--gray-bg,
.v-card.empty-state--gray-bg .v-card__text,
.empty-state__content--gray {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

.theme--dark .v-card.empty-state--gray-bg,
.theme--dark .v-card.empty-state--gray-bg .v-card__text,
.theme--dark .empty-state__content--gray {
  background-color: rgba(255, 255, 255, 0.04) !important;
}
</style>
